<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>{{ info.storeName }}</h1>
    </div>
    <b-card>
      <b-row class="gx-2">
        <b-col md="2">
          <MenuInner
            :activeItem="activeItem"
            :DetailMenus="DetailMenus"
            :id="id"
            :maId="id"
            :maName="info.storeName"
          >
          </MenuInner>
        </b-col>
        <b-col md="10">
          <div>
            <h3>Lịch sử gỡ gán</h3>
            <b-table
              hover
              sticky-header
              responsive
              :items="historyConfig"
              :fields="fieldsConfig"
              :fixed="true"
              :bordered="true"
              :busy.sync="isLoading"
              style="margin-top: 10px"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle" />
                </div>
              </template>
              <template #empty>
                <div class="text-center text-info my-2">Không có dữ liệu</div>
              </template>
              <template #emptyfiltered="{ emptyFilteredText }">
                <h4>{{ emptyFilteredText }}</h4>
              </template>
              <template #cell(staffAssignId)="{ item }">
                <div>
                  {{
                    `${item.staffName} - ${item.staffTypes.map(type => asignType[type]).join(', ')}`
                  }}
                </div>
                <div>
                  <span class="text-muted">Loại</span>:
                  {{ item.configType == 'MAIN' ? 'Chính' : 'Phụ' }}
                </div>
              </template>
              <template #cell(creator)="{ item }">
                <div v-if="item.type === 'REMOVE'">
                  <div v-if="item.creator">
                    <span class="text-muted">Người gỡ gán</span>:
                    {{ item.creator?.name }}
                  </div>
                  <div v-if="item.createdTime">
                    <span class="text-muted">Thời gian gỡ gán</span>:
                    {{ formatDate(item.createdTime) }}
                  </div>
                </div>
              </template>
            </b-table>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { historyAssign } from '@/services/customer-support/store-staff'
  import { Detail } from '@/services/customer-support/store'
  import { showMess } from '@/config/utils'
  import MenuInner from '@/pages/customer-support/cskh/account/components/MenuInner'
  import moment from 'moment'
  import { asignType, DetailMenus } from '@/pages/customer-support/cskh/store/components/constant'

  export default {
    components: {
      MenuInner,
    },
    data() {
      return {
        isLoading: false,
        id: '',
        level: 'STORE',
        info: [],
        historyAssign: [],
        historyConfig: [],
        fieldsConfig: [
          {
            key: 'staffAssignId',
            label: 'Nhân viên chăm sóc',
            sortable: false,
            thStyle: 'width: 100px; text-align: center',
          },
          {
            key: 'creator',
            label: 'Người/Thời gian gỡ gán',
            sortable: false,
            thStyle: 'width: 80px; text-align: center',
          },
          {
            key: 'reason',
            label: 'Lý do',
            sortable: false,
            thStyle: 'width: 80px; text-align: center',
          },
        ],
        DetailMenus,
        asignType,
        activeItem: 'lich_su_go_gan',
      }
    },
    created() {
      this.id = this.$router.currentRoute.params.id
    },

    async mounted() {
      if (this.dataPermission.includes('CNPS_CSS_MA_DETAIL')) {
        await this.getHistoryAssign()
        this.toggleSideBar()
        await this.GetDetail()
      } else {
        this.$bvModal
          .msgBoxOk('Bạn không có quyền truy cập vào trang này', {
            title: 'Cảnh báo',
            // size: 'sm',
            // buttonSize: 'sm',
            okVariant: 'danger',
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            centered: true,
          })
          .then(value => {
            // chuyển trang
            this.$router.replace('/')
          })
      }
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    methods: {
      formatDate(date, format = 'HH:mm, DD/MM/YYYY') {
        if (!date) return
        return moment(date).format(format)
      },
      toggleSideBar() {
        this.$store.commit('dom/SET_SIDEBAR_STATUS', !this.isOpen)
      },
      async getHistoryAssign() {
        try {
          this.isLoading = true
          const res = await historyAssign({
            assignmentId: this.id,
            level: this.level,
          })
          this.historyConfig = res.data.logHistoryConfigs.filter(item => item.type === 'REMOVE')
        } catch (e) {
          showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
          this.isLoading = false
        } finally {
          this.isLoading = false
        }
      },
      async GetDetail() {
        try {
          // this.isLoading = true;
          const res = await Detail(this.id)
          this.info = res.data
        } catch (e) {
          showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        } finally {
          // this.isLoading = false;
        }
      },
    },
  }
</script>
